export const reaction = context => (type, id, reaction_type) => ({
    type: 'REACTION.TOGGLE',
    payload: {type, id, reaction_type},
    context
});